const siteSearch = ({
  site,
  urlTemplate,
}: {
  site: string;
  urlTemplate: string;
}): string => {
  const jsonLd = `{
    "@context": "https://schema.org",
    "@type": "WebSite",
    "url": "${site}",
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "${urlTemplate}"
      },
        "query-input": "required name=search_term_string"
    }
  }`;

  return jsonLd;
};

export default siteSearch;
